<template>
  <VCard class="d-md-flex advice-card">
    <VCarousel
      ref="carousel"
      v-if="advices"
      hide-delimiters
      :show-arrows="false"
      :height="$vuetify.breakpoint.xsOnly ? 270 : 190"
    >
      <DashboardAdviceItem v-for="(item,index) in advices" :key="index" :item="item">
        <div class="advice-card__buttons-wrap">
          <button
            class="advice-card__btn advice-card__btn_prev"
            @click="prev"
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="40"
                height="40"
                rx="4"
                transform="matrix(-1 0 0 1 40 0)"
                fill="white"
              />
              <path d="M20 12L21.41 13.41L15.83 19H28V21H15.83L21.41 26.59L20 28L12 20L20 12Z" fill="black" />
            </svg>
          </button>

          <button
            class="advice-card__btn advice-card__btn_next"
            @click="next"
          >
            <svg
              class="next-icon"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="40"
                height="40"
                rx="4"
                fill="white"
              />
              <path d="M20 12L18.59 13.41L24.17 19H12V21H24.17L18.59 26.59L20 28L28 20L20 12Z" fill="black" />
            </svg>
          </button>
        </div>
      </DashboardAdviceItem>
    </VCarousel>
  </VCard>
</template>

<script>
import { useI18n } from 'vue-i18n-composable';
import { ref } from '@vue/composition-api';
import DashboardAdviceItem from '@/components/Dashboard/DashboardAdviceItem';
import { SUPPORT_EMAIL } from '@/helpers/constants';

export default {
  name: 'DashboardAdvice',
  components: { DashboardAdviceItem },
  setup() {
    const { t } = useI18n();
    const carousel = ref(null);

    const advices = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const item in t('advices')) {
      const advice = t('advices')[item];
      if (advice.text) {
        advice.text = advice.text.replace('{email}', SUPPORT_EMAIL);
      }
      advices.push(advice);
    }

    function next() {
      carousel.value.next();
    }

    function prev() {
      carousel.value.prev();
    }

    return {
      advices,
      carousel,
      next,
      prev,
    };
  },
};
</script>

<style lang="scss" scoped>
.advice-card {
  height: 100%;
  color: #000000;
  background: #FFFFFF;
  border-radius: 0.625rem;
  margin-left: 0.625rem;
  line-height: 1.375;
  padding: 1.875rem;
  position: relative;
  &.v-card {
    box-shadow: 0 2px 0.5rem rgba(0, 0, 0, 0.16);
  }
  &__buttons-wrap {
    position: absolute;
    bottom: 1.875rem;
    right: 0;
    z-index: 10;
  }
}
@media #{map-get($display-breakpoints, 'md-and-down')} {
  .advice-card {
    margin-left: 0;
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  .advice-card {
    padding: 1.25rem;
    &__buttons-wrap {
      bottom: 0;
    }
  }
}
</style>
<i18n locale="en" lang="yaml">
  advices:
    - title: 'How to get more candidate interviews #1'
      text: 'When you invite candidates, we recommend choosing additional communication channels, such as text messages or robocalls.
      That way, candidates are guaranteed to receive your invitation.'
      image: 'advice.png'
    - title: 'How to get more candidate interviews #2'
      text: 'Try to interview candidates promptly after receiving their response.
      Candidates actively seeking work are more likely to record an interview,
       compared to those who showed interest in your job opening a month ago.'
      image: 'advice.png'
    - title: 'How to get more candidate interviews #3?'
      text: 'The sooner candidates receive your invitation for a video interview, the higher the likelihood that they will record one.
      Set up an auto-response in your e-mail inbox that sends candidates a link for an interview on Huntica.'
      image: 'advice.png'
    - title: 'You can record an interview at your office!'
      text: "Each candidate's profile page features a function to record an in-person interview. All you need is a laptop with a webcam or a smartphone.
    These interviews will assist your colleagues in making hiring decisions, even if they cannot be there in person."
      image: 'advice.png'
    - title: 'Integrate Huntica with your website'
      text: "Candidates can easily record online interviews without leaving the career page on your company's website.
      To initiate the integration process, contact us at {email}, and we will provide you with instructions."
      image: 'advice.png'
</i18n>
<i18n locale="ru" lang="yaml">
  advices:
    - title: 'Как повысить количество откликов #1'
      text: 'При приглашении кандидатов рекомендуем выбирать дополнительный способ оповещения: СМС или звонок автоинформатором. Так кандидат гарантированно получит ваше приглашение.'
      image: 'advice.png'
    - title: 'Как повысить количество откликов #2'
      text: 'Старайтесь приглашать кандидатов сразу после того, как получите отклик! Если кандидат прямо сейчас находится в поиске работы, то вероятность,
      что он запишет интервью существенно выше, чем если он интересовался вакансией более месяца назад.'
      image: 'advice.png'
    - title: 'Как повысить количество откликов #3'
      text: 'Чем быстрее кандидат получит приглашение на видео-интервью, тем выше шанс, что он его пройдёт. Настройте в своём почтовом ящике автоответ на письма кандидатов и отправляйте им ссылку на собеседование на Huntica.'
      image: 'advice.png'
    - title: 'Можно записывать интервью в офисе!'
      text: 'В карточке кандидата есть функция записи офисного собеседования. Вам потребуется лишь ноутбук с веб-камерой или смартфон! Запись очного собеседования поможет вашим коллегам принять решение о найме, даже если они не смогли присутствовать лично.'
      image: 'advice.png'
    - title: 'Интегрируйте Huntica в ваш сайт'
      text: 'Кандидаты смогут пройти видео-собеседование, не покидая карьерный раздел вашего сайта. Чтобы настроить интеграцию, напишите нам на {email}, и мы вышлем инструкцию.'
      image: 'advice.png'
    - title: 'Настройте интеграцию с Работа.ру'
      text: 'Интеграция с Работа.ру позволяет автоматически отправлять приглашения кандидатам, когда они откликаются на вашу вакансию. Чем быстрее кандидат получит приглашение после отклика – тем более вероятно, что он пройдёт собеседование! '
      image: 'advice.png'
    - title: 'Удобное приглашение кандидатов с hh.ru'
      text: 'Приглашайте кандидатов с hh.ru с помощью расширения для Google Chrome. После установки и авторизации расширения, на странице анкеты кандидата появится кнопка «Пригласить в Huntica»'
      image: 'advice.png'

</i18n>
